import { c as _c } from "react/compiler-runtime";
import { useWallet } from "@solana/wallet-adapter-react";
import { useEffect } from "react";
import { useSnapshot } from "valtio";
import { AccountActions, AccountState } from "../accountStore";
export const useSyncAccountStoreWithSolanaAccount = t0 => {
  const $ = _c(15);
  const {
    siweAdapter
  } = t0;
  const {
    wallet
  } = useWallet();
  const {
    chainArch,
    shouldSyncAccountState
  } = useSnapshot(AccountState);
  const connecting = wallet?.adapter.connecting;
  const connected = wallet?.adapter.connected;
  const publicKey = wallet?.adapter.publicKey;
  let t1;
  if ($[0] !== chainArch || $[1] !== connected || $[2] !== connecting || $[3] !== publicKey || $[4] !== shouldSyncAccountState || $[5] !== siweAdapter || $[6] !== wallet) {
    t1 = () => {
      if (chainArch !== "SVM") {
        return;
      }
      if (connecting) {
        AccountActions.setIsConnecting(true);
        return;
      }
      let accountInput;
      if (connected && publicKey) {
        accountInput = getAccountInput(publicKey, wallet, siweAdapter);
      } else {
        accountInput = undefined;
      }
      AccountActions.setExternalAccount(accountInput);
      if (!shouldSyncAccountState) {
        return;
      }
      AccountActions.setAccount(accountInput);
    };
    $[0] = chainArch;
    $[1] = connected;
    $[2] = connecting;
    $[3] = publicKey;
    $[4] = shouldSyncAccountState;
    $[5] = siweAdapter;
    $[6] = wallet;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== chainArch || $[9] !== connected || $[10] !== connecting || $[11] !== publicKey || $[12] !== shouldSyncAccountState || $[13] !== siweAdapter) {
    t2 = [chainArch, connecting, connected, publicKey, siweAdapter, shouldSyncAccountState];
    $[8] = chainArch;
    $[9] = connected;
    $[10] = connecting;
    $[11] = publicKey;
    $[12] = shouldSyncAccountState;
    $[13] = siweAdapter;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  useEffect(t1, t2);
};
function getAccountInput(publicKey, wallet, siweAdapter) {
  return {
    address: publicKey.toBase58(),
    chainId: 1,
    connectorId: wallet.adapter.name.toString(),
    addresses: [publicKey.toBase58()],
    // If siweAdapter is present then ready will be set when the account is authenticated
    ...(siweAdapter ? {} : {
      ready: true
    })
  };
}